import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Input } from '@/components/ui/input';
import { Save, CheckCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SettingsEditor() {
  const [settings, setSettings] = useState({});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const fetchSettings = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/admin/settings`, { withCredentials: true });
      setSettings(res.data || {});
    } catch { setSettings({}); }
  }, []);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  const up = (k, v) => { setSettings(prev => ({ ...prev, [k]: v })); setSaved(false); };

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/api/admin/settings`, settings, { withCredentials: true });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      alert('Failed: ' + (err.response?.data?.detail || err.message));
    } finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Contact Settings</h1>
        <button onClick={handleSave} disabled={saving} className="bg-[#F2B705] text-black font-bold text-xs uppercase px-5 py-2.5 hover:bg-[#D9A404] flex items-center gap-2 disabled:opacity-50">
          {saved ? <><CheckCircle size={14} /> Saved</> : <><Save size={14} /> {saving ? 'Saving...' : 'Save'}</>}
        </button>
      </div>

      <div className="bg-[#161616] border border-white/10 p-6 space-y-5">
        <div><label className="text-xs uppercase text-[#888] font-bold mb-1 block">Business Address</label>
          <Input value={settings.business_address || ''} onChange={e => up('business_address', e.target.value)} className="bg-transparent border-white/10 text-white text-sm h-10 focus:border-[#F2B705]" /></div>
        <div><label className="text-xs uppercase text-[#888] font-bold mb-1 block">Email Address</label>
          <Input value={settings.email || ''} onChange={e => up('email', e.target.value)} className="bg-transparent border-white/10 text-white text-sm h-10 focus:border-[#F2B705]" /></div>
        <div><label className="text-xs uppercase text-[#888] font-bold mb-1 block">Phone Number</label>
          <Input value={settings.phone || ''} onChange={e => up('phone', e.target.value)} className="bg-transparent border-white/10 text-white text-sm h-10 focus:border-[#F2B705]" /></div>
        <div><label className="text-xs uppercase text-[#888] font-bold mb-1 block">Contact Form Recipient Email</label>
          <Input value={settings.contact_form_recipient || ''} onChange={e => up('contact_form_recipient', e.target.value)} className="bg-transparent border-white/10 text-white text-sm h-10 focus:border-[#F2B705]" /></div>
        <div><label className="text-xs uppercase text-[#888] font-bold mb-1 block">Website URL</label>
          <Input value={settings.website || ''} onChange={e => up('website', e.target.value)} className="bg-transparent border-white/10 text-white text-sm h-10 focus:border-[#F2B705]" /></div>
      </div>
    </div>
  );
}
